if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


// const sizeTabs = document.querySelectorAll('.size-tabs span');
// const sizeLabels = document.querySelectorAll('.size_label'); // Assuming you want to hide elements with the class "size_label"
// if(sizeTabs){
// sizeTabs.forEach(function(tab) {
//   tab.addEventListener('click', function() {
//     // Remove the "active" class from all sizeTabs
//     sizeTabs.forEach(function(sizeTab) {
//       sizeTab.classList.remove('active');
//     });

//     // Add the "active" class to the clicked tab
//     tab.classList.add('active');

//     const dataValue = tab.getAttribute('data'); // Get the 'data' attribute value
//     // Hide all elements with the class "size_label"
//     sizeLabels.forEach(function(label) {
//       label.style.display = 'none'; // Assuming you want to hide the elements
//       label.classList.remove('active');
//     });
//      const correspondingElement = document.querySelectorAll(`.${dataValue}`);
//     // Show the corresponding elements with the same class name
//     correspondingElement.forEach(function(element) {
//       element.style.display = 'block'; // Assuming you want to show the elements
//       element.classList.add('active');
//     });
// var activeSpanText = document.querySelector('.size_input:checked').nextElementSibling.querySelector('span.active').textContent;
// var formLabels = document.querySelector('.form__label span');
//           formLabels.textContent = activeSpanText;
//   });
// });
// }


// const sizeInputs = document.querySelectorAll('.size_input');
// if(sizeInputs){
//   sizeInputs.forEach(function(input) {
//     input.addEventListener('change', function() {
//       const nextLabel = input.nextElementSibling; // Get the next sibling element (assuming it's the label)
      
//       if (nextLabel) {
//         const activeSpan = nextLabel.querySelector('span.active'); // Find the active span element
//         if (activeSpan) {
//           var activeSpanText = activeSpan.textContent; // Get the text of the active span
//         var formLabels = document.querySelector('.form__label span');
//           formLabels.textContent = activeSpanText;
//         }
//       }
//     });
//   });
// }

// const sizeGuideBtn = document.querySelector('.sizeGuide_btn');
// const productPopupOpener = document.querySelector('.product-popup-modal__button');

// sizeGuideBtn.addEventListener('click', function() {
//   productPopupOpener.click(); // Trigger a click on the .sizeGuide_btn element
// });


$(document).ready(function () {
  var sizeTabs = $('.size-tabs span');
  var sizeLabels = $('.size_label');
  sizeTabs.on('click', function () {
    // Remove the "active" class from all sizeTabs
    sizeTabs.removeClass('active');
    // Add the "active" class to the clicked tab
    $(this).addClass('active');
    var dataValue = $(this).attr('data');
    // Hide all elements with the class "size_label"
    sizeLabels.hide().removeClass('active');
    // Show the corresponding elements with the same class name
    $('.' + dataValue).show().addClass('active');
    var activeSpanText = $('.size_input:checked').next().find('span.active').text();
    $('.form__label span').text(activeSpanText);
  });
  var sizeInputs = $('.size_input');
  sizeInputs.on('change', function () {
    var nextLabel = $(this).next();
    if (nextLabel.length > 0) {
      var activeSpan = nextLabel.find('span.active');
      if (activeSpan.length > 0) {
        var activeSpanText = activeSpan.text();
        $('.form__label span').text(activeSpanText);
      }
    }
  });

  var sizeGuideBtn = $('.sizeGuide_btn');
  var productPopupOpener = $('.product-popup-modal__button');
  sizeGuideBtn.on('click', function () {
    productPopupOpener.click();
  });
});
